import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/allocation/styles.scss';export default {
  "allocation": "_allocation_1s20e_1",
  "removeAllocation": "_removeAllocation_1s20e_6",
  "resource": "_resource_1s20e_10",
  "container": "_container_1s20e_19",
  "label": "_label_1s20e_27",
  "center": "_center_1s20e_33",
  "avatar": "_avatar_1s20e_37",
  "user": "_user_1s20e_44",
  "name": "_name_1s20e_57",
  "title": "_title_1s20e_63",
  "allocatedHours": "_allocatedHours_1s20e_68",
  "completionCheck": "_completionCheck_1s20e_85",
  "binIcon": "_binIcon_1s20e_93"
};